var dataTableCommon = (function () {
    var dateFormat = 'DD.MM.YYYY';
    var dateTimeFormat = 'DD.MM.YYYY HH:mm';

    function renderDate(data, type, row, meta) {
        if (type === 'display') {
            if (!data) {
                return '-';
            }

            if (data.indexOf(':') !== -1) {
                return moment(data, moment.ISO_8601).format(dateTimeFormat);
            } else {
                return moment(data, moment.ISO_8601).format(dateFormat);
            }
        }

        if (type === 'sort') {
            if (!data) {
                return 0;
            }

            return moment(data, moment.ISO_8601).unix();
        }

        return data;
    }

    function addTooltipToComment($tableNode, tableSelector) {
        $tableNode.find('.mdi-comment').on('click', function () {
            Swal.fire({
                title: $(this).attr('data-comment'),
                confirmButtonColor: '#188ae2'
            });
        });

        $(`${tableSelector} tbody`).on('click', '.mdi-comment', function (e) {
            Swal.fire({
                title: $(this).attr('data-comment'),
                confirmButtonColor: '#188ae2'
            });
            return false;
        });
    }

    return {
        renderDate: renderDate,
        addTooltipToComment: addTooltipToComment
    };

})();
